import { searchParser } from 'helpers';

const locationParser = (destinations, code) => {
  const location = searchParser(destinations, code, true);

  if (location) return location[0];
  else {
    return {};
  }
};

export default locationParser;
